import {
	Box,
	Card,
	CardContent,
	Snackbar
} from '@material-ui/core';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { AxiosError } from 'axios';
import * as React from 'react';
import { useState } from 'react';
import ExcelPreviewComponent from '../../../components/ExcelPreview/excel-preview.component';
import { IErrorResponse, IFileResponse } from '../../../models';
import { EFileAnalyzerService } from '../../../services/eFileAnalyzer.service';
import { SharedService } from '../../../services/shared.service';
import * as Constant from '../../../shared/constants';
import EFileAnalyzerForm, { IEFileAnalyzerFormValues } from './efile-analyzer-form.component';

function Alert(props: AlertProps) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}


const EFileAnalyzerTool : React.FC = () => {
	const [disableForm, setDisableForm] = useState<boolean>();
	const [file, setFile] = useState<IFileResponse>();
	const [snackbarState, setSnackbarState] = useState<boolean>();
	const [errorMessage, setErrorMessage] = useState<string>();

	const analyze = async (val: IEFileAnalyzerFormValues) => {
		setDisableForm(false);
		const { result, fileName } = await sendEFileAnalyzeRequest(val);
		setFile({fileContents: result.data, fileDownloadName: fileName})
		setDisableForm(true);
	};

	const sendEFileAnalyzeRequest = async ({ analyzerType, fileContent }: IEFileAnalyzerFormValues) => {
		try {
			const formData = new FormData();
			formData.append('analyzerType', analyzerType);
			formData.append('eFile', new Blob([fileContent]), 'EFile');
			
			const eFileAnalyzerService = new EFileAnalyzerService();
			const result = await eFileAnalyzerService.sendEFileAnalyzeRequest(formData);
			const fileName = new SharedService().parseContentDisposition(
				result.request.getResponseHeader(Constant.contentDispositionHeader)
			);
			setDisableForm(true);
			return { result, fileName };
		} catch (err: any) {
			const errdata = err as AxiosError;
			if (errdata!.response) {
				const error: IErrorResponse = JSON.parse(await errdata!.response.data.text());
                setErrorMessage(error.message);
            }
			setSnackbarState(true);
			throw err;
		}
	};

	const handleReset = () => {
		setDisableForm(false);
		setFile(undefined);
	}

	return (
		<>
			<Card>
				<CardContent>
					<EFileAnalyzerForm onSubmit={analyze} onReset={handleReset} disableFormInput={disableForm ?? false} />
				</CardContent>
				<Snackbar open={snackbarState} autoHideDuration={6000} onClose={() => setSnackbarState(false)}>
					<Alert severity="error">{errorMessage}</Alert>
				</Snackbar>
			</Card>
			{ file && <Box mt={2}>
				<Card>
					<CardContent>
						<ExcelPreviewComponent file={file} />
					</CardContent>
				</Card>
			</Box>}
		</>
	);
}

export default EFileAnalyzerTool;

